import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getActiveChip } from "core-integration/src/store/chips/reducers";
import { getElementTypesById } from "core-integration/src/store/element-types/reducers";
import { updateElementTypeControl } from "core-integration/src/store/elements/thunks";
import { getProposedElements } from "core-integration/src/store/squad/reducers";
import {
  proposeElement,
  removeElement,
} from "core-integration/src/store/squad/thunks";
import { useDispatch, useSelector } from "react-redux";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import PlusIcon from "../../img/icons/plus-icon.svg?react";
import { IconButton } from "../buttons/IconButton";
import { addIcon, removeIcon } from "./addElement.css";
import { AddElementProps } from "./types";

const AddElement = ({
  element,
  filterByElementTypeOnRemove,
}: AddElementProps) => {
  const { addPlayer: addPlayerText, removePlayer: removePlayerText } =
    usePlosTranslations();
  const chip = useSelector(getActiveChip);

  const dispatch = useDispatch<ThunkDispatch>();

  const addElement = (elementId: number) => {
    dispatch(proposeElement(elementId));
  };

  // Find which position contains this element and remove it
  const removeProposedElement = (elementId: number) => {
    const position = Object.keys(proposedElements).find(
      (pos) => proposedElements[Number(pos)]?.id === elementId,
    );

    if (position) {
      dispatch(removeElement(Number(position)));
      if (filterByElementTypeOnRemove) {
        dispatch(updateElementTypeControl(element.element_type));
      }
    }
  };

  const proposedElements = useSelector((state: RootState) =>
    getProposedElements(state, undefined, chip?.id),
  );

  // Check if element exists in any position
  const isInSquad = Object.values(proposedElements).some(
    (el) => el?.id === element.id,
  );

  // Get the element types and the max you can select for this type
  const elementTypes = useSelector(getElementTypesById);
  const elementTypeMax = elementTypes[element.element_type].squad_select;

  // Count how many elements of this type are already selected
  const elementTypeCount = Object.values(proposedElements).filter(
    (el) => el.element_type === element.element_type,
  ).length;

  const isDisabled = elementTypeCount >= elementTypeMax;

  const addLabel = addPlayerText(element.web_name);
  const removeLabel = removePlayerText(element.web_name);

  return isInSquad ? (
    <IconButton
      icon={<PlusIcon className={removeIcon} />}
      label={removeLabel}
      appearance="tonal"
      onPress={() => removeProposedElement(element.id)}
    />
  ) : (
    <IconButton
      icon={<PlusIcon className={addIcon} />}
      label={addLabel}
      appearance="tonal"
      isDisabled={isDisabled}
      onPress={() => addElement(element.id)}
    />
  );
};

export default AddElement;
